import React, { useState } from "react";

const Description = ({ Description }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleDescription = () => {
    setExpanded(!expanded);
  };

  const truncatedText = Description.length > 150 ? Description.slice(0, 150) + "..." : Description;

  return (
    <div className="mt-5 animate-slide-in">
      <h2 className="text-2xl font-bold mb-2 text-orange-500">Description</h2>
      <p className="text-gray-700 text-sm leading-relaxed">
        {expanded ? Description : truncatedText}
        {Description.length > 150 && (
          <button 
            onClick={toggleDescription} 
            className="text-blue-500 ml-2 underline text-sm font-semibold"
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        )}
      </p>
    </div>
  );
};

export default Description;
